if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) {
          cartNotification.init();
          cartNotification.setActiveElement(this.openedBy);
        }

        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        publish(PUB_SUB_EVENTS.quickViewClose);
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden', 'spinning-complete');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);

            // Homepage equipment cards use the real product form so variant and
            // pricing logic stays authoritative.  The product template also
            // contains long-form SEO, specifications, media and support blocks;
            // those belong on the product page, not in the compact option drawer.
            if (this.id.startsWith('QuickAdd-Hub-')) {
              productElement.classList.add('amc-home-quick-add-product');
              productElement
                .querySelectorAll(
                  '.product__media-wrapper, .amc-product-information, .amc-pdp-assurance, .amc-quality-signals-disclosure, .amc-quality-signals, .product__description, .product__accordion, share-button, .product__social, [id^="ProductMediaInfo-"]'
                )
                .forEach((element) => element.remove());
            }

            // Remove elements from QB that shouldn't be there
            productElement.querySelectorAll('.quick-add-hidden').forEach((elem) => {
              elem.remove();
            });

            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            super.show(opener);

            publish(PUB_SUB_EVENTS.quickViewOpen);
            publish('quick-buy-action-complete');

            setTimeout(() => {
              if (window.ProductModel) window.ProductModel.loadShopifyXR();
            }, 500);

          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden', 'spinning-complete');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
        this.prependProductTitle(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section.replaceAll('quickadd-', '');

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      prependProductTitle(productElement) {
        const container = productElement.querySelector('section.product__info-container .product__info-container');
        if (container) {
          const productTitleHTML = `
            <div class="product__title">
              <a href="${productElement.dataset.url}" class="link un-underlined-link">
                <h2 class="h2 mt-0">
                  ${productElement.dataset.productTitle}
                  <span class="product__read-more block underlined-link t4">${window.strings.product.readMore}</span>
                </h2>
              </a>
            </div>`;
          container.innerHTML = productTitleHTML + container.innerHTML;
        }
      }
    }
  );
}
